import { cx } from "@/utils";

import styles from "./Badge.module.css";

type BadgeVariant = "default" | "error" | "success";

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({
  variant = "default",
  children,
  className,
}) => {
  return (
    <span
      className={cx(
        styles.badge,
        variant === "error" && styles.error,
        variant === "success" && styles.success,
        variant === "default" && styles.default,
        className
      )}
    >
      {children}
    </span>
  );
};

export default Badge;
